import React, { useEffect } from 'react';
import type { ViewProps } from 'react-native';
import { StyleSheet } from 'react-native';
import { Main } from '@expo/html-elements';
import {
  COLORS,
  SPACING,
  useBreakpointHelpers,
  useFunctionPolling,
} from '@sweetgreen/garnish';

import { AppFooter, PageWrapper } from '@order/components';
import { useCart } from '@order/hooks';

export const CheckoutWrapper = (props: ViewProps) => {
  const { fetchCart } = useCart();
  const { matchByBreakpointIndex } = useBreakpointHelpers();

  const responsiveStyle = matchByBreakpointIndex([
    styles.wrapperMobile,
    styles.wrapperTablet,
    styles.wrapperDesktop,
  ]);
  const style = [styles.wrapper, responsiveStyle];

  const containerResponsiveStyle = matchByBreakpointIndex([
    {},
    styles.containerTabletUp,
    styles.containerDesktopUp,
  ]);
  const containerStyles = [styles.container, containerResponsiveStyle];

  // ─── EFFECTS ─────────────────────────────────────────────────────

  // fetch the cart on mount (and re-fetch on interval)
  useEffect(fetchCart, [fetchCart]);
  useFunctionPolling(30 * 1000, fetchCart);

  // ─────────────────────────────────────────────────────────────────

  return (
    <PageWrapper
      withHeaderTitle
      withoutFooter
      contentContainerStyle={style}
      testID="sg-order-checkout-wrapper"
    >
      <Main style={containerStyles}>{props.children}</Main>
      <AppFooter />
    </PageWrapper>
  );
};

//
// ─── STYLES ─────────────────────────────────────────────────────────────────────
//

const styles = StyleSheet.create({
  wrapper: {
    flexGrow: 1,
    backgroundColor: COLORS.QUINOA,
  },
  wrapperMobile: {
    backgroundColor: COLORS.OATMEAL,
  },
  wrapperTablet: {
    paddingTop: SPACING.large,
  },
  wrapperDesktop: {
    paddingTop: SPACING.xlarge,
  },
  container: {
    width: '100%',
    alignSelf: 'center',
    paddingHorizontal: SPACING.medium,
    paddingBottom: SPACING.large,
  },
  containerTabletUp: {
    maxWidth: 500,
  },
  containerDesktopUp: {
    maxWidth: 1024,
  },
});
